// extracted by mini-css-extract-plugin
module.exports = {"lia-guide-article":"GuideItem_lia-guide-article__9BEX_"};